export default __webpack_public_path__ + "static/media/coach_meter_mg@2x.b6cf42d2.webp";